module.exports = __webpack_public_path__ + "static/media/historiek-min.37049f40.png";